  (function(){
    let showImageDialog = (imgUrl) => {
      let targetHTML = '<div class="abit-dialog-body"><img class="abit-the-lazy-img" alt="dialog content image" src="' + imgUrl + '" alt=""></div>';
      let mask = document.querySelector(".abit-dialog-mask");
      if(!mask) {
        mask = document.createElement("div"); mask.className = "abit-dialog-mask"; document.body.appendChild(mask);
        mask.addEventListener("click", (e)=>{ if(e.target.classList.contains("abit-dialog-mask")) {mask.classList.add("d-none");return true;} else {e.stopPropagation();e.preventDefault();return false;} });
        mask.innerHTML = '<div class="abit-dialog-body"><img class="abit-the-lazy-img" alt="dialog content image" src="' + imgUrl + '" alt=""></div>';
      } else {
        if(mask.innerHTML != targetHTML) {
          mask.innerHTML = targetHTML;
        }
        mask.classList.remove("d-none");
      }
      // add close button
      if(!mask.querySelector(".abit-dialog-close")) {
        let btn = document.createElement("button");
        btn.className = "div-like big-sized abit-dialog-close";
        btn.innerHTML = `<svg aria-hidden="true" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 1.625L1 11" stroke="black"/><path d="M1.625 1L11 11" stroke="black"/></svg>`;
        mask.appendChild(btn);
        btn.addEventListener("click",(e)=>{ mask.classList.add("d-none");return true; });
      }
    };

    const cloneAndDelClass = function(el, delClasses) {
      const copy = el.cloneNode(true);
      if(delClasses && delClasses.length > 0) {
        delClasses.forEach(delClass => { copy.classList.remove(delClass); })
      }
      return copy;
    };

    let aSec = document.querySelector(".announcement-bar.shopify-section");
    if(!aSec) {
      let announcement = document.createElement('div');
      announcement.className = "shopify-section shopify-section-group-header-group announcement-bar";
      announcement.innerHTML = '<div class="bg-white bg-announcement"><div class="announcement-bar text-center container"></div></div>';
      document.querySelector("header").prepend(announcement);
      aSec = announcement;
    }
    if(aSec.children && aSec.children.length > 0 && aSec.children[0]){
      aSec.children[0].classList.add("bg-announcement");
    if(location.pathname != '/')
      aSec.children[0].classList.add("bg-announcement-fixed");

    }
    bSec = aSec.querySelector(".announcement-bar.container");
    // bSec.innerHTML = document.querySelector(".as-announcement-contents").outerHTML;
    bSec.innerHTML = '';
    bSec.appendChild(cloneAndDelClass(document.querySelector(".as-announcement-contents"), ["ac-v1", "ac-v2"]));
    
    Array.from(bSec.querySelectorAll(".ac-link")).every((link) => {
      if(link.dataset.href != "none") {
        link.classList.add("ac-link-clickable");
        link.addEventListener("click", () => {
          window.location.href = link.dataset.href;
        });
      }
      if(link.dataset.image && link.dataset.image != "none") {
        link.classList.add("ac-link-clickable");
        link.addEventListener("click", () => {
          showImageDialog(link.dataset.image);
        });
      }
      return true;
    });

  })()